import log from 'loglevel'

const environment = import.meta.env.VITE_TARGET_ENVIRONMENT

if (environment === 'syft-dev' || environment === 'syft-staging' || environment === 'syft-beta') {
  log.setLevel(log.levels.TRACE)
} else {
  log.setLevel(log.levels.ERROR)
}

function serializeError(error) {
  const plainObject = {}
  Object.getOwnPropertyNames(error).forEach(key => {
    plainObject[key] = error[key]
  })
  return plainObject
}

const originalError = log.error.bind(log)

// Lazy-loaded analytics to avoid circular dependency
let analyticsRelay = null
let analyticsPromise = null

log.error = function (message, ...args) {
  try {
    originalError(message, ...args)

    // Track error if analytics is available
    if (analyticsRelay) {
      console.log('analyticsRelay exists')
      // Serialize error because it's an object
      const argsSerialized = args.length > 0 ? serializeError(args[0]) : null
      analyticsRelay.trackError(message, argsSerialized)
    } else if (!analyticsPromise) {
      console.log('analyticsPromise does not exist')

      // Start loading analytics if not already loading
      analyticsPromise = import('@/plugins/analyticsRelay')
        .then(module => {
          analyticsRelay = module.default
          // Track this error that triggered the load
          const argsSerialized = args.length > 0 ? serializeError(args[0]) : null
          analyticsRelay.trackError(message, argsSerialized)
        })
        .catch(err => {
          console.error('Failed to load analytics relay:', err)
          // Reset promise so we can retry later
          analyticsPromise = null
        })
    }
    // If analyticsPromise exists but analyticsRelay doesn't, we're currently loading
    // In this case, we skip tracking (edge case skipped - back to back errors in < 100 ms)
  } catch (e) {
    console.error('Error logging error', e)
  }
}

export { log }
